<template>
  <ProductCarousel :title="_T('@Buy with this product')" :products="products" />
</template>

<script setup>
import ProductCarousel from "~/modules/shared/sliders/ProductCarousel.vue";
import { useAPI, useAsyncAPI } from "~/uses/useMyFetch";
import { Product } from "~/models/product.model";
import { setProductsPurchaseOrigin } from "~/utils/product.utils";

const props = defineProps({
  product: { type: Product, required: true },
});

const products = ref(null);

const httpClient = () => {
  return import.meta.client ? useAPI : useAsyncAPI;
};

const fetch = async (httpClient) => {
  return httpClient("/catalog/product/list/related", {
    params: {
      productId: props.product.id,
      limit: 6,
    },
  }).then((data) => {
    const dtoProducts = data.data ?? data;

    products.value = dtoProducts
      .filter((product) => product.isOrderable)
      .map((product) => new Product(product));

    setProductsPurchaseOrigin(products.value, "related");
  });
};

watch(
  () => props.product,
  () => {
    fetch(httpClient());
  },
  { deep: true, immediate: true },
);
</script>
